import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba1a1b3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
      /*#__PURE__*/_createElementVNode("h1", null, "Heat Chart")
    ])
  ])
], -1))
const _hoisted_2 = {
  key: 0,
  class: "row m-3"
}
const _hoisted_3 = { class: "table table-bordered table-sm" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  style: {"width":"100px"}
}, "Area", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  style: {"width":"40px"}
}, "1", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  style: {"width":"40px"}
}, "2", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  style: {"width":"40px"}
}, "3", -1))
const _hoisted_8 = { class: "align-middle" }
const _hoisted_9 = { class: "coverage-cell text-center" }
const _hoisted_10 = { class: "coverage-cell text-center" }
const _hoisted_11 = { class: "coverage-cell text-center" }
const _hoisted_12 = ["onClick"]

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import _ from "lodash";
import locationsData from "@/assets/json/locations.json";
import LocationsPagination from "@/components/inspectors/LocationsPagination.vue";
import { Location, Inspector } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'AreaHeatChart',
  setup(__props) {

const store = useStore();
const filteredLocations = ref([] as any[]);

// Getting inspectors from the store
const inspectors = computed(() => store.getters['diary/inspectorlist']);

const setCurrentInspector = (inspector: Inspector) => {
  store.commit('inspectors/setCurrentInspector', inspector);
};
const setInspectorDeep = async (payload: { path: string; data: any }) => {
  await store.dispatch('inspectors/setInspectorDeep', payload);
};
const updateCoverageRating = async (inspector: Inspector) => {
  await store.dispatch('inspectors/updateCoverageRating', inspector);
}

// Computed property for sorted inspectors
const sortedinspectors = computed(() => {
  return inspectors.value.filter((i: Inspector) => i.id).sort((i1: Inspector, i2: Inspector) =>
    i1.name.localeCompare(i2.name)
  );
});

// Computed property for all locations
const allLocations = computed(() => {
  return locationsData.sort((l1: any, l2: any) => l1.code.localeCompare(l2.code));
});

// Method for getting coverage class
const getCoverageClass = (location: Location, inspector: Inspector) => {
  let loc: Location | undefined = inspector.locations.find(
    (l: Location) => l.code.trim() === location.code.trim()
  );
  let cls: string = "rating-0";
  if (loc) {
    if (loc.rating == 1) cls = "rating-1";
    else if (loc.rating == 2) cls = "rating-2";
    else if (loc.rating == 3) cls = "rating-3";
  }
  return cls;
};

// Method for getting coverage
const getCoverage = (location: Location, inspector: Inspector) => {
  let loc: Location | undefined = inspector.locations.find(
    (l: Location) => l.code.trim() === location.code.trim()
  );
  return loc ? loc.rating : "-";
};

// Method for getting tally
const getTally = (location: Location, rating: number) => {
  let list = inspectors.value.filter((i: Inspector) =>
    i.locations.find(
      (l: Location) => l.code.trim() === location.code.trim() && l.rating === rating
    )
  );
  return list && list.length ? list.length : "-";
};

// Method for filtering locations
const filterLocations = (startsWith: string) => {
  filteredLocations.value = locationsData
    .filter((l: any) => {
      return String(l.code).toLowerCase().startsWith(startsWith.toLowerCase());
    })
    .sort((l1: any, l2: any) => l1.code.localeCompare(l2.code));
};

const changeCoverage = (inspector: Inspector, location: Location) => {
  setCurrentInspector(inspector);
  const locIndex = inspector.locations.findIndex((l: Location) =>  l.code.trim() === location.code.trim());
  if(locIndex >= 0) {
    // The location is already in the list
    const l: Location = inspector.locations[locIndex];
    if(l.rating === 3) {
      // Make the rating zero by remocing location from inspector location list
      inspector.locations.splice(locIndex, 1);
      setInspectorDeep({path: 'locations', data: [...inspector.locations]});
    }
    else {
      setInspectorDeep({path: `locations[${locIndex}].rating`, data: l.rating + 1});
    }
  }
  else {
    inspector.locations.push(new Location(location));
    setInspectorDeep({path: 'locations', data: [...inspector.locations]});
  }
  updateCoverageRating(inspector);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(LocationsPagination, { onFilter: filterLocations }),
    (inspectors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedinspectors.value, (inspector) => {
                  return (_openBlock(), _createElementBlock("th", {
                    style: {"width":"40px"},
                    class: "rotate",
                    key: inspector.id
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(inspector.name), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLocations.value, (location, $index) => {
              return (_openBlock(), _createElementBlock("tbody", { key: $index }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(location.code), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(getTally(location, 1)), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(getTally(location, 2)), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(getTally(location, 3)), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedinspectors.value, (inspector) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: inspector.id,
                      class: _normalizeClass([getCoverageClass(location, inspector), "text-center"]),
                      onClick: ($event: any) => (changeCoverage(inspector, location))
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(getCoverage(location, inspector)), 1)
                      ])
                    ], 10, _hoisted_12))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})